<div *ngIf="isSuccess"><ng-content select=".success"></ng-content></div>
<div *ngIf="isWarning"><ng-content select=".warning"></ng-content></div>
<div *ngIf="isError"><ng-content select=".error"></ng-content></div>
<div *ngIf="isDeleted"><ng-content select=".deleted"></ng-content></div>
<div *ngIf="isAccessDenied"><ng-content select=".access-denied"></ng-content></div>
